import React from "react";
import { icons } from "../../assets/icons";

export const ButtonReturn = ({ callback = () => { } }) => {

	return (
		<div className="fixed z-40 top-[80px] right-5">
			<div onClick={callback} className="w-12 h-12 p-3 rounded-full bg-[#00000074] cursor-pointer">
				<img className="h-full w-full object-contain" src={icons.returnbutton} alt="play" />
			</div>
		</div>
	);
};
